import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { DailyBlockReport } from './Pages'

export const DailyBlockReportRoutes = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={DailyBlockReport} />
    </Fragment>
)